export enum AmplitudeProperties {
  Timestamp = "timestamp",
  UserId = "user_id",
  OperatingSystemInformation = "operating_system_information",
  DeviceInformation = "device_information",
  BrowserInformation = "browser_information",
  Language = "language",
  App = "app",
  Height = "height",
  Width = "width",
  PageName = "page_name",
  Path = "path",
  TreatmentId = "treatment_id",
  TreatmentTemplateKey = "treatment_template_key",
  ScreenResolution = "screen_resolution",
  OrganizationId = "organization_id",
  Fps = "fps",
  AvailableMemory = "available_memory",
  PoseTrackingFrequency = "pose_tracking_frequency",
  FpsHealth = "fps_health",
  MemoryHealth = "memory_health",
  PoseTrackingHealth = "pose_tracking_health",
  NetworkBandwidthMbps = "network_bandwidth_mbps",
  NetworkBandwidthQuality = "network_bandwidth_quality",
  NetworkBandwidthHealth = "network_bandwidth_health",
  MaiaLatencyMs = "maia_latency_ms",
  MaiaLatencyHealth = "maia_latency_health",
  BatteryLevel = "battery_level",
  BatteryCharging = "battery_charging",
  BatteryAvailable = "battery_available",
  BatteryHealth = "battery_health",
  GpuIntegrated = "gpu_integrated",
  GpuDiscrete = "gpu_discrete",
  GpuCpu = "gpu_cpu",
  GpuAvailable = "gpu_available",
  GpuHealth = "gpu_health",
  PreviousPageVisitedPath = "previous_page_visited_path",
  UsersPortalRole = "users_portal_role",
}

export enum SessionAmplitudeProperties {
  ScreenType = "screen_type",
  ScreenIndex = "screen_index",
  ScreenDurationAtExit = "screen_duration_at_exit",
  IsInitialSession = "is_initial_session",
  SessionLogIndex = "session_log_index",
  SessionLogId = "session_log_id",
  CurrentPhaseWeek = "current_phase_week",
  ScreenState = "screen_state",
}

export type PropertyTypeMap = {
  [AmplitudeProperties.Timestamp]: number;
  [AmplitudeProperties.UserId]: string;
  [AmplitudeProperties.OperatingSystemInformation]: string;
  [AmplitudeProperties.DeviceInformation]: string;
  [AmplitudeProperties.BrowserInformation]: string;
  [AmplitudeProperties.Language]: string;
  [AmplitudeProperties.App]: string;
  [AmplitudeProperties.Height]: number;
  [AmplitudeProperties.Width]: number;
  [AmplitudeProperties.PageName]: string;
  [AmplitudeProperties.Path]: string;
  [AmplitudeProperties.TreatmentId]: string;
  [AmplitudeProperties.TreatmentTemplateKey]: string;
  [AmplitudeProperties.ScreenResolution]: string;
  [AmplitudeProperties.OrganizationId]: string;
  [AmplitudeProperties.BatteryLevel]: number;
  [AmplitudeProperties.BatteryCharging]: boolean;
  [AmplitudeProperties.BatteryAvailable]: boolean;
  [AmplitudeProperties.BatteryHealth]: string;
  [AmplitudeProperties.GpuIntegrated]: string;
  [AmplitudeProperties.GpuDiscrete]: string;
  [AmplitudeProperties.GpuCpu]: string;
  [AmplitudeProperties.GpuAvailable]: boolean;
  [AmplitudeProperties.GpuHealth]: string;
};

export type ScreenStateType = "camera_in_center" | "coach_in_center";

export type SessionPropertyTypeMap = {
  [SessionAmplitudeProperties.ScreenType]: string;
  [SessionAmplitudeProperties.ScreenIndex]: number;
  [SessionAmplitudeProperties.IsInitialSession]: boolean;
  [SessionAmplitudeProperties.CurrentPhaseWeek]: number;
  [SessionAmplitudeProperties.SessionLogId]: string;
  [SessionAmplitudeProperties.ScreenDurationAtExit]: number | null;
  [SessionAmplitudeProperties.SessionLogIndex]: number;
  [SessionAmplitudeProperties.ScreenState]: ScreenStateType;
};

export enum SessionScreenTypes {
  IntroVideo = "Intro Video",
  InstructionsScreen = "Instructions Screen",
  RoutineScreen = "Routine Screen",
  BreakScreen = "Break Screen",
  PauseScreen = "Pause Screen",
  CooldownScreen = "Cooldown Screen",
  CooldownSelection = "Cooldown Selection Screen",
}

export enum AmplitudeCustomPropertiesEnum {
  EventCause = "event_cause",
  SelectionEnumList = "selection_enum_list",
}

export enum EventCauseEnum {
  FloatingCloseButton = "floating_close_button",
  SessionOverviewButton = "session_overview_button",
  BackToExerciseButton = "back_to_exercise_button",
  NextSessionButton = "next_session_button",
  PreviousExerciseButton = "previous_exercise_button",
  NextExerciseButton = "next_exercise_button",
  Navigate = "navigate",
}

export type PortalEventInfo = {
  [AmplitudeProperties.PreviousPageVisitedPath]: string;
  [AmplitudeProperties.Timestamp]: number;
  [AmplitudeProperties.UserId]: string;
  [AmplitudeProperties.OrganizationId]: string;
  [AmplitudeProperties.UsersPortalRole]: string;
  [AmplitudeProperties.Language]: string;
  [AmplitudeProperties.OperatingSystemInformation]: string;
  [AmplitudeProperties.BrowserInformation]: string;
  [AmplitudeProperties.App]: string;
  [AmplitudeProperties.Height]: number;
  [AmplitudeProperties.Width]: number;
  [AmplitudeProperties.PageName]: string;
  [AmplitudeProperties.Path]: string;
};

export type AmplitudeCustomProperties = {
  [AmplitudeCustomPropertiesEnum.EventCause]?: EventCauseEnum;
  [AmplitudeCustomPropertiesEnum.SelectionEnumList]?: string[];
};

export type TrackEventFunction = (eventName: string, eventData: Record<string, unknown>) => void;
